import React from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { doChangePassword } from '../modules/auth/stores/thunk';

const ChangePasswordModal = ({ open, onClose, forced = false }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.common.globalLoading);

  const handleSubmit = async (values) => {
    try {
      await dispatch(
        doChangePassword({
          currentPassword: values.currentPassword,
          newPassword: values.newPassword,
        }),
      ).unwrap();

      message.success('Password changed successfully');
      form.resetFields();
      if (onClose) onClose();
    } catch (error) {
      const msg = error?.message || error?.data?.message || 'Failed to change password';
      message.error(Array.isArray(msg) ? msg[0] : msg);
    }
  };

  return (
    <Modal
      title={forced ? 'You must change your password' : 'Change Password'}
      open={open}
      closable={!forced}
      maskClosable={!forced}
      keyboard={!forced}
      footer={null}
      onCancel={forced ? undefined : onClose}
    >
      <p style={{ marginBottom: 16, color: '#616161' }}>
        {forced
          ? 'For security reasons, you need to set a new password before continuing.'
          : 'Enter your current password and choose a new one.'}
      </p>
      <Form form={form} layout="vertical" requiredMark={false} onFinish={handleSubmit}>
        <Form.Item
          label="Current Password"
          name="currentPassword"
          rules={[{ required: true, message: 'Please enter your current password' }]}
        >
          <Input.Password placeholder="Current password" autoComplete="current-password" />
        </Form.Item>
        <Form.Item
          label="New Password"
          name="newPassword"
          rules={[
            { required: true, message: 'Please enter a new password' },
            { min: 6, message: 'Password must be at least 6 characters' },
          ]}
        >
          <Input.Password placeholder="New password" autoComplete="new-password" />
        </Form.Item>
        <Form.Item
          label="Confirm New Password"
          name="confirmPassword"
          dependencies={['newPassword']}
          rules={[
            { required: true, message: 'Please confirm your new password' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Passwords do not match'));
              },
            }),
          ]}
        >
          <Input.Password placeholder="Confirm new password" autoComplete="new-password" />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          {!forced && (
            <Button onClick={onClose} style={{ marginRight: 8 }}>
              Cancel
            </Button>
          )}
          <Button type="primary" htmlType="submit" loading={loading}>
            Change Password
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
